import moment from 'moment'
import momentTZ from 'moment-timezone'
import * as config from '../const'

export const getMeetingStatus = meeting => {
  if (moment() > moment(meeting.end_at)) return config.MEETING_ENDING
  return meeting.status
}

export function getListYear (periodYear) {
  let listYear = []
  const currentYear = moment().year()
  const pastYear = moment().year() - (periodYear + 1)
  const futureYear = moment().year() + (periodYear + 1)
  for (let i = currentYear; pastYear < i; --i) {
    listYear = [{value: i, label: `${i} 年`}, ...listYear]
  }
  for (let i = currentYear + 1; i < futureYear; i++) {
    listYear = [...listYear, {value: i, label: `${i} 年`}]
  }
  return listYear
}

export function getMonths () {
  let months = []
  for (let i = 1; i <= 12; i++) {
    months.push(
      {
        value: i,
        label: `${i} 月`
      }
    )
  }
  return months
}

export function zeroPadNumber (number) {
  if (number < 10) {
    return `0${number}`
  }
  return number
}

export function checkStatusResponse (response) {
  if (response.status === 200) {
    return true
  } else {
    return false
  }
}

export const isPatientUser = user => user.type === config.USER_TYPE_PATIENT
export const isPharmacistUser = user => user.type === config.USER_TYPE_PHARMACIST
export const isOtherUser = user => user.type === config.USER_TYPE_OTHER

export function isShareScreenStream (uid) {
  return uid.toString().length > 3 && uid.toString().endsWith('100')
}

export function getUserFromListWithDeviceId (users, deviceId) {
  const index = _.findIndex(users, u => u.device_id === deviceId)
  if (index < 0) return null
  return users[index]
}

export function getUidFromShareScreenUid (uid) {
  return parseInt(uid.toString().substring(0, uid.toString().length - 3))
}

export function convert2LocalTime (time, tz, format = 'Y-MM-DD HH:mm:ss') {
  return momentTZ
    .tz(time, 'Asia/Tokyo')
    .clone()
    .tz(tz)
    .format(format)
}

export function convert2ServerTime (time, tz, format = 'Y-MM-DD HH:mm:ss') {
  return momentTZ
    .tz(time, tz)
    .clone()
    .tz('Asia/Tokyo')
    .format(format)
}

export function getStatus () {
  const status = [
    {value: 'all', label: 'ステータスを選択'},
    {value: 'pending', label: '申請中'},
    {value: 'accepted', label: '確定'},
    {value: 'finished', label: '終了'},
    {value: 'canceled', label: '取り消し'},
    {value: 'discontinuation', label: '中止'}
  ]
  return status
}

export function fixMomentInvalidDate (string) {
  const arr = string.split('-')
  if (arr.length >= 3) {
    arr[1] = zeroPadNumber(parseInt(arr[1]))
    arr[2] = zeroPadNumber(parseInt(arr[2]))
    return arr.join('-')
  }
}

export function apiErrorDialog (vue, error) {
  let modalTitle = '不明なエラーが発生しました'
  let modalMessage = 'しばらく時間をおいて再度お試し下さい'
  if (error.response && error.response.status === 409) {
    modalTitle = '予約状態が変更されました'
    modalMessage = error.response.data && error.response.data.message
      ? error.response.data.message
      : '最新状態を確認してください。'
    return vue.$alert(modalMessage, modalTitle, {
      confirmButtonText: 'OK',
      cancelButtonText: '',
      forceRender: true,
      type: 'warning'
    })
  }
  if (error.response && error.response.status >= 500 && error.response.data.maintenance) {
    modalTitle = error.response.data.maintenance.title
    modalMessage = error.response.data.maintenance.message
  }

  vue.$alert(modalMessage,modalTitle,{
    confirmButtonText: 'ポケミを再読み込み',
    cancelButtonText: '',
    forceRender: true,
    type: 'warning'
  }).then(() => {
    vue.$loading.show({opacity: 1})
    setTimeout(() => {
      window.location.reload()
    }, 1000)

  })

}



// WEBPACK FOOTER //
// ./src/helpers/index.js